import _useBreakpoint from 'use-breakpoint';
import breakpoints from 'constants/breakpoints';

const useBreakpoint = () => _useBreakpoint(breakpoints, 'xl');

export default useBreakpoint;
